/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { checkoutSessionsControllerCreateCheckoutSession } from '../fn/checkout-sessions/checkout-sessions-controller-create-checkout-session';
import { CheckoutSessionsControllerCreateCheckoutSession$Params } from '../fn/checkout-sessions/checkout-sessions-controller-create-checkout-session';
import { checkoutSessionsControllerCreatePackageCheckoutSession } from '../fn/checkout-sessions/checkout-sessions-controller-create-package-checkout-session';
import { CheckoutSessionsControllerCreatePackageCheckoutSession$Params } from '../fn/checkout-sessions/checkout-sessions-controller-create-package-checkout-session';
import { ResponseCheckoutSessionDto } from '../models/response-checkout-session-dto';

@Injectable({ providedIn: 'root' })
export class CheckoutSessionsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `checkoutSessionsControllerCreateCheckoutSession()` */
  static readonly CheckoutSessionsControllerCreateCheckoutSessionPath = '/keus-payments/checkout-sessions';

  /**
   * Create a checkout session.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `checkoutSessionsControllerCreateCheckoutSession()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  checkoutSessionsControllerCreateCheckoutSession$Response(params: CheckoutSessionsControllerCreateCheckoutSession$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseCheckoutSessionDto>> {
    return checkoutSessionsControllerCreateCheckoutSession(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a checkout session.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `checkoutSessionsControllerCreateCheckoutSession$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  checkoutSessionsControllerCreateCheckoutSession(params: CheckoutSessionsControllerCreateCheckoutSession$Params, context?: HttpContext): Observable<ResponseCheckoutSessionDto> {
    return this.checkoutSessionsControllerCreateCheckoutSession$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseCheckoutSessionDto>): ResponseCheckoutSessionDto => r.body)
    );
  }

  /** Path part for operation `checkoutSessionsControllerCreatePackageCheckoutSession()` */
  static readonly CheckoutSessionsControllerCreatePackageCheckoutSessionPath = '/keus-payments/checkout-sessions/package';

  /**
   * Create checkout session for Fertility Check-in package.
   *
   * Creates an immediate payment checkout session for the Fertility Check-in package. Unlike regular visits which use setup intent for scheduled payments, this charges immediately.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `checkoutSessionsControllerCreatePackageCheckoutSession()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  checkoutSessionsControllerCreatePackageCheckoutSession$Response(params: CheckoutSessionsControllerCreatePackageCheckoutSession$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseCheckoutSessionDto>> {
    return checkoutSessionsControllerCreatePackageCheckoutSession(this.http, this.rootUrl, params, context);
  }

  /**
   * Create checkout session for Fertility Check-in package.
   *
   * Creates an immediate payment checkout session for the Fertility Check-in package. Unlike regular visits which use setup intent for scheduled payments, this charges immediately.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `checkoutSessionsControllerCreatePackageCheckoutSession$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  checkoutSessionsControllerCreatePackageCheckoutSession(params: CheckoutSessionsControllerCreatePackageCheckoutSession$Params, context?: HttpContext): Observable<ResponseCheckoutSessionDto> {
    return this.checkoutSessionsControllerCreatePackageCheckoutSession$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseCheckoutSessionDto>): ResponseCheckoutSessionDto => r.body)
    );
  }

}
